<template>
    <div class="container-fluid px-0">
        <nav>
            <ol class="breadcrumb m-0">
                <li class="breadcrumb-item"><router-link to="/mypage">マイページ</router-link></li>
                <li class="breadcrumb-item"><router-link :to="booksPath">小説管理</router-link></li>
                <li class="breadcrumb-item">本文一覧</li>
            </ol>
        </nav>
        <div class="container px-0">
            <div class="row m-0">
                <div class="col-md-12">
                    <legend class="novel-title mincho">
                        <i class="fas fa-eye-slash" v-if="book.is_hidden" :class="{
                            'text-warning': book.is_hidden === 2,
                            'text-danger': book.is_hidden === 3,
                        }" data-toggle="tooltip" :title="hiddenLevel"></i>
                        <span v-html="$filters.ruby(book.title)"></span>
                        <span class="badge gothic" v-if="book.rating" :class="{
                            'badge-warning': book.rating.rating_name == 'R15',
                            'badge-danger': book.rating.rating_name == 'R18',
                            'badge-dark': book.rating.rating_name == 'XXX',
                        }">
                            {{book.rating.rating_name}}
                        </span>
                        <span class="badge badge-success" v-if="book.is_backup" data-toggle="tooltip" title="メールバックアップ">
                            <i class="fas fa-envelope-open-text"></i>
                        </span>
                        <span class="badge badge-warning" v-if="book.has_epub" data-toggle="tooltip" title="完結時に電子書籍化">
                            <i class="fas fa-book-open"></i>
                        </span>
                        <a :href="url" v-if="BookisPublished" target="_blank" class="novel-link">
                            小説ページ
                            <i class="fas fa-external-link-alt"></i>
                        </a>
                        <h5 v-html="$filters.ruby(book.subtitle)"></h5>
                    </legend>
                </div>
            </div>
            <div class="row m-0">
                <div class="col-md-4 book-status">
                    <div class="row noline" v-if="book.cover_url">
                        <img :src="book.cover_url + '?' + book.cover_hash" class="img-fluid img-thumbnail mx-auto d-block cover" />
                    </div>
                    <div class="sticky container sideinfo" v-if="book.property">
                        <div class="row m-0">
                            <div class="col-12">
                                <div class="desc" :class="{'show': show_desc}" v-html="$filters.ruby(book.description)"></div>
                                <div class="desc-more" @click="toggleDesc()">
                                    <i class="fas fa-chevron-down" v-if="!show_desc"></i>
                                    <i class="fas fa-chevron-up" v-else></i>
                                </div>
                            </div>
                        </div>
                        <div class="row m-0" v-if="book.genre">
                            <div class="col-4"><strong>ジャンル</strong></div>
                            <div class="col-8">
                                {{book.genre.genre_name}}
                            </div>
                        </div>
                        <div class="row m-0">
                            <div class="col-4"><strong>話数</strong></div>
                            <div class="col-8">
                                {{ $filters.numberFormat(episodes) }} 話
                                <span v-if="book.is_long" class="badge badge-primary">長編</span>
                                <span v-else class="badge badge-warning">短編</span>
                                <span class="badge" v-if="sequel" :class="{
                                    'badge-warning': sequel === '連載中',
                                    'badge-dark': sequel === '完結',
                                    'badge-secondary': sequel === '完結予定',
                                }">{{sequel}}</span>
                            </div>
                        </div>
                        <div class="row m-0" v-if="book.series">
                            <div class="col-4"><strong>シリーズ</strong></div>
                            <div class="col-8">
                                {{book.series.series_name}}
                                <i class="fas fa-layer-group" v-if="book.series.is_group"></i>
                            </div>
                        </div>
                        <div class="row m-0" v-if="book.property.first_published_at">
                            <div class="col-4"><strong>初回公開</strong></div>
                            <div class="col-8">
                                {{$filters.dateFormat(book.property.first_published_at)}}
                            </div>
                        </div>
                        <div class="row m-0" v-if="book.property.last_published_at">
                            <div class="col-4"><strong>最終更新</strong></div>
                            <div class="col-8">
                                {{$filters.dateFormat(book.property.last_published_at)}}
                            </div>
                        </div>
                        <div class="row m-0" v-if="book.property">
                            <div class="col-4"><strong>文字数</strong></div>
                            <div class="col-8">
                                <span>{{$filters.numberFormat(book.property.published_chars)}}</span>
                                /
                                <span>{{$filters.numberFormat(book.property.characters)}}</span>
                                文字
                            </div>
                        </div>
                        <div class="row m-0" v-if="book.tags && book.tags.length">
                            <div class="col-4"><strong>タグ</strong></div>
                            <div class="col-8">
                                <ul class="tag-list mx-0">
                                    <li v-for="t in book.tags" :key="t.id">
                                        {{t.tag_name}}
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="row m-0">
                            <div class="col-4"><strong>投稿サイト</strong></div>
                            <div class="col-8">
                                <site v-for="u in book.urls" :url="u.url" :domain="u.domain" :key="u.id"></site>
                                <button type="button" class="btn btn-light btn-sm" @click="showSites()">
                                    <i class="fas fa-edit"></i>
                                </button>
                            </div>
                        </div>
                        <div class="row m-0">
                            <div class="col-4"><strong>拍手ボタン</strong></div>
                            <div class="col-8">
                                <span class="badge mx-1" :class="{
                                    'badge-info': a.can_review,
                                    'badge-secondary': !a.can_review,
                                }" v-for="a in book.applause" :key="a.id">
                                    {{a.caption}}
                                    <span v-if="crapCount(a)">{{crapCount(a)}}</span>
                                    <span v-if="crapDiff(a)" class="small">+{{crapDiff(a)}}</span>
                                </span>
                                <button type="button" class="btn btn-light btn-sm" @click="showApplause()">
                                    <i class="fas fa-edit"></i>
                                </button>
                            </div>
                        </div>
                        <div class="row m-0" v-if="book.banner">
                            <div class="col-4"><strong>リンクバナー</strong></div>
                            <div class="col-8">
                                <img :src="book.banner.picture.url +'?'+ book.banner.picture.hash" class="img-thumbnail img-link">
                            </div>
                        </div>
                        <div class="row m-0" v-if="chapters.length">
                            <div class="col-4"><strong>章</strong></div>
                            <div class="col-8">
                                <div v-for="c in chapters" :key="c.id">
                                    <a href="#" @click.prevent="scrollTo(c)">{{c.section_name}}</a>
                                </div>
                            </div>
                        </div>
                        <div class="row m-0">
                            <div class="col-xl-12 text-center">
                                <div class="btn-group btn-block">
                                    <router-link :to="'/mypage/book/' + book.id + '/edit'" class="btn btn-outline-primary btn-sm">
                                        <i class="fas fa-edit"></i>
                                        小説情報編集
                                    </router-link>
                                    <router-link :to="'/mypage/book/' + book.id + '/notes/edit'" class="btn btn-outline-warning btn-sm">
                                        <i class="far fa-sticky-note"></i>
                                        ノート編集
                                    </router-link>
                                </div>
                            </div>
                            <div class="col-xl-12 text-center">
                                <div class="btn-group btn-block">
                                    <router-link :to="'/mypage/book/' + book.id + '/plot'" class="btn btn-outline-success btn-sm" v-if="book.is_long">
                                        <i class="fas fa-chart-line"></i>
                                        プロット
                                    </router-link>
                                    <router-link :to="'/mypage/book/' + book.id + '/outlines'" class="btn btn-outline-success btn-sm" v-if="book.is_long">
                                        <i class="fas fa-chalkboard"></i>
                                        あらすじ
                                    </router-link>
                                    <router-link :to="'/mypage/book/' + book.id + '/backgrounds'" class="btn btn-outline-secondary btn-sm">
                                        <i class="fas fa-images"></i>
                                        背景画像
                                    </router-link>
                                </div>
                            </div>
                            <div class="col-xl-12 text-center">
                                <div class="btn-group w-100 btn-dropdown">
                                    <button type="button" class="btn btn-outline-secondary dropdown-toggle btn-sm btn-block" data-toggle="dropdown">
                                        <i class="fas fa-download"></i>
                                        全文ダウンロード
                                    </button>
                                    <div class="dropdown-menu">
                                        <a :href="'/mypage/book/download/' + book.id" class="dropdown-item">
                                            UTF-8 + LF (Mac/UNIX)
                                        </a>
                                        <a :href="'/mypage/book/download/' + book.id + '?sjis=1'" class="dropdown-item">
                                            Shift_JIS + CRLF (Windows)
                                        </a>
                                        <a :href="`/author/book/epub?id=${this.book.id}`" class="dropdown-item">
                                            電子書籍（EPUB）
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-8">
                    <div class="sticky">
                        <nav class="navbar navbar-expand-lg b-normal bg-blur">
                            <button class="navbar-toggler" type="button"
                                data-toggle="collapse" data-target="#navbarTogglerDemo01"
                                aria-controls="navbarTogglerDemo01" aria-expanded="false"
                                aria-label="Toggle navigation"
                                v-if="isToggler">
                                <span class="navbar-toggler-icon"></span>
                            </button>
                            <div class="collapse navbar-collapse" id="navbarTogglerDemo01" v-if="!isSorted && !isScheduled">
                                <div class="my-3 ml-1">
                                    <button type="button" class="btn btn-outline-danger btn-sm" @click="removeAll()" v-if="removable">
                                        <i class="fas fa-times"></i>
                                        下書き一括削除
                                    </button>
                                    <button type="button" class="btn btn-outline-success btn-sm" @click="showUpload()" v-if="book.is_long && !sections.length">
                                        <i class="fas fa-upload"></i>
                                        ファイル
                                    </button>
                                    <button type="button" class="btn btn-outline-primary btn-sm" @click="showSerial()" v-if="book.is_long && sections.length">
                                        <i class="fas fa-sort-numeric-down"></i>
                                        タイトル
                                    </button>
                                    <router-link class="btn btn-outline-warning btn-sm" :to="recentUrl" v-if="book.is_long && sections.length && recent" :title="recentTitle">
                                        <i class="fas fa-edit"></i>
                                        {{$filters.truncate(recentTitle, 15)}}
                                    </router-link>
                                </div>
                            </div>
                            <ul class="navbar-nav mr-auto" v-if="isSorted || isScheduled">
                                <li class="nav-item">
                                    <a href="#" class="btn btn-outline-success btn-sm my-2" @click.prevent="updateStatus()">
                                        <i class="fas fa-check"></i>
                                        <span v-if="isSorted">順番</span>
                                        <span v-if="isScheduled">予定</span>
                                        更新
                                    </a>
                                    <a href="#" class="btn btn-outline-secondary btn-sm my-2" @click.prevent="load()">
                                        <i class="fas fa-times-circle"></i>
                                        <span v-if="isSorted">順番</span>
                                        <span v-if="isScheduled">予定</span>
                                        キャンセル
                                    </a>
                                </li>
                            </ul>
                            <div class="ml-1" v-if="!isSorted && !isScheduled">
                                <button type="button" class="btn btn-outline-primary btn-sm" :disabled="isSorted || isScheduled" @click="editChapter()" v-if="book.is_long">
                                    <i class="fas fa-folder-open"></i>
                                    章追加
                                </button>
                                <router-link
                                    v-if="canAppend"
                                    :to="`/mypage/book/${$route.params.book_id}/section/edit/new`"
                                    tabindex="-1"
                                    role="button"
                                    class="btn btn-outline-primary btn-sm"
                                    :class="{disabled: isSorted || isScheduled}">
                                    <i class="fas fa-plus"></i>
                                    本文追加
                                </router-link>
                            </div>
                        </nav>
                    </div>
                    <div v-for="(v, i) in sections" :key="v.id" class="card w-100 section bg-blur"
                        :class="{'b-air': v.is_chapter, 'selected': v.id == selected.id}"
                        :id="`section-${v.id}`">
                        <div class="card-body">
                            <div class="row no-gutters">
                                <div :class="{
                                    'col-xl-10': !v.is_chapter,
                                    'col-xl-12': v.is_chapter,
                                }">
                                    <h5 class="card-title section-title my-1 d-flex justify-content-between">
                                        <router-link :to="`/mypage/book/${$route.params.book_id}/section/edit/${v.id}`" v-if="!v.is_chapter" class="black">
                                            <span class="small text-muted" v-if="book.is_long">
                                                {{ $filters.numberFormat(v.order) }}.
                                            </span>
                                            {{v.section_name}}
                                            <span class="text-muted" v-if="!v.section_name">（無題）</span>
                                            <i class="fas fa-image" v-if="v.backgrounds.length == 1"></i>
                                            <i class="fas fa-images" v-else-if="v.backgrounds.length > 1"></i>
                                        </router-link>
                                        <span v-else class="font-weight-bold">
                                            {{v.section_name}}
                                        </span>
                                        <span class="badge badge-danger" v-if="v.is_finish">
                                            最終話
                                        </span>
                                    </h5>
                                </div>
                                <div class="col-xl-2 text-right" v-if="!v.is_chapter">
                                    <div class="small">
                                        {{$filters.numberFormat(v.characters)}} 文字
                                    </div>
                                </div>
                            </div>
                            <div class="row no-gutters" v-if="!v.is_chapter">
                                <div class="col-xl-12">
                                    <div class="publish-schedule">
                                        <span class="publish_at" :class="{
                                            'text-danger': !v.publish_org || isInvalid(i),
                                            'text-success': v.publish_org && !isPublished(v.publish_org) && !isInvalid(i),
                                            'text-secondary': isPublished(v.publish_org) && !isInvalid(i)
                                        }" @click="showPicker(v)">
                                            <span v-if="v.publish_org">
                                                <i class="far fa-clock" v-if="!isPublished(v.publish_at)"></i>
                                                <i class="far fa-check-circle" v-else></i>
                                                {{$filters.dateFormat(v.publish_org)}}
                                            </span>
                                            <span v-else>下書き</span>
                                            <i v-if="!isInvalid(i)" class="fas fa-caret-down"></i>
                                            <span v-else>
                                                <i class="fas fa-exclamation-circle"></i>
                                            </span>
                                        </span>
                                        <span v-if="v.publish_org != v.publish_at">→</span>
                                        <span v-if="v.publish_org != v.publish_at" :class="{
                                            'text-danger': !v.publish_at,
                                            'text-success': v.publish_at && !isPublished(v.publish_at),
                                            'text-secondary': isPublished(v.publish_at)
                                        }" @click="showPicker(v)">
                                            <span v-if="v.publish_at">
                                                {{$filters.dateFormat(v.publish_at)}}
                                            </span>
                                            <span v-else>下書き</span>
                                        </span>
                                        <a href="#"
                                            class="badge badge-pill badge-light pointer"
                                            v-if="v.publish_org != v.publish_at"
                                            @click.prevent="v.publish_at = v.publish_org">
                                            キャンセル
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div class="row no-gutters" v-if="v.applause">
                                <span class="badge badge-pills mr-1" :class="{
                                    'badge-info' : a.can_review,
                                    'badge-secondary' : !a.can_review,
                                }" v-for="a in v.applause" :key="a.id">
                                    {{a.caption}}
                                    {{$filters.numberFormat(a.pivot.count)}}
                                    <span v-if="a.pivot.count > a.pivot.known_count" class="small"> + {{a.pivot.count - a.pivot.known_count}}</span>
                                </span>
                            </div>
                            <div class="row no-gutters d-flex justify-content-end">
                                <button type="button" class="btn btn-link btn-sm" @click="editChapter(v.id)"
                                    v-if="v.is_chapter"
                                    :disabled="isSorted || isScheduled">
                                    <i class="fas fa-edit"></i> 編集
                                </button>
                                <router-link
                                    :to="`/mypage/book/${$route.params.book_id}/section/edit/${v.id}`"
                                    role="button"
                                    :class="{disabled: isSorted || isScheduled}"
                                    class="btn btn-link btn-sm" v-else>
                                    <i class="fas fa-edit"></i> 編集
                                </router-link>
                                <button type="button" class="btn btn-link btn-sm" @click="moveSection(v)" v-if="sections.length > 1">
                                    <i class="fas fa-sort"></i> 移動
                                </button>
                                <button type="button" class="btn btn-link text-danger btn-sm" @click="deleteChapter(v.id)"
                                    v-if="v.is_chapter"
                                    :disabled="isSorted || isScheduled">
                                    <i class="fas fa-times-circle"></i> 削除
                                </button>
                                <button type="button" class="btn btn-link text-danger btn-sm"
                                    :disabled="isSorted || isScheduled" @click="remove(v)" v-else>
                                    <i class="fas fa-times-circle"></i> 削除
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="alert alert-secondary" style="margin-top: 1em;" v-if="!sections.length">
                        まだ話がありません。
                        右上の「新規話追加」ボタンから、新しいお話を追加してください。
                    </div>
                </div>
            </div>
        </div>
        <chapter
            :book_id="$route.params.book_id"
            :chapter_id="chapter_id"
            @saved="load($event)"
            @closed="chapter_id = null"></chapter>
        <section-move
            :section="section"
            :sections="sections"
            @moveTo="moveTo($event)"></section-move>
        <upload
            :book_id="$route.params.book_id"
            @saved="load()"></upload>
        <serial :book_id="$route.params.book_id"
            @saved="load()"></serial>
        <loading
            v-model:active="isLoading"
            :can-cancel="true"
            :is-full-page="false"></loading>
        <publish-picker
            :selected="selected"
            :title="true"
            :apply="true"
            :spanned="true"
            :book="book"
            @save="closePicker($event)"></publish-picker>
        <sites :book_id="$route.params.book_id" @saved="loadBook()"></sites>
        <applause :book_id="$route.params.book_id" @saved="load()"></applause>
    </div>
</template>

<style scoped lang="scss">
.cover {
    object-fit: cover;
    height: 546px;
    width: 388px;
}
.img-link {
    width: calc(200px + 0.5rem + 2px);
    height: calc(40px + 0.5rem + 2px);
}
.sideinfo {
    overflow: scroll;
    max-height: calc(100vh - 92px);
    -ms-overflow-style: none;
    scrollbar-width: none;
    &::-webkit-scrollbar{
        display:none;
    }
}
.btn-edit {
    margin: 1em 0;
}
.btn-no-border {
    &:hover {
        background-color: #ccc;
    }
}
.btn-dropdown.show {
    margin-bottom: 8rem;
}
.section-title {
    font-size: 1.0rem;
}
.section {
    margin: 1em 0;
}
.novel-link {
    font-size: 0.9rem;
}
.badge {
    font-size: 14px;
}
.publish_at {
    font-size: .8rem;
    font-weight: normal;
}
.publish-schedule {
    cursor: pointer;
    font-size: .8rem;
}
.unpublish {
    font-size: 1.2rem;
}
.card.selected {
    border: 2px solid #bbe;
}
.book-status {
    .row {
        border-bottom: 1px dashed #aaa;
        [class^="col-"] {
            padding: .5rem 0;
        }
        &.noline {
            border: 0;
        }
    }
    .container {
        padding: 0;
    }
}
.novel-title {
    font-size: 1.4rem;
}
.desc {
    max-height: 3rem;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    &.show {
        max-height: none;
        display: block;
    }
}
.desc-more {
    text-align: center;
    cursor: pointer;
    &:hover {
        color: #5555a4;
    }
}
@media screen and (max-width: 770px) {
    .col-md-8 {
        padding-right: .25rem;
        padding-left: .25rem;
    }
}
</style>

<script>
import chapter from "./modals/chapter";
import sectionMove from "./modals/section-move";
import upload from "./modals/upload";
import serial from "./modals/serial";
import publishPicker from "./modals/publishPicker";
import Site from "components/Site";
import sites from "./modals/sites";
import applause from "./modals/applause";
export default {
    components: {
        chapter,
        sectionMove,
        upload,
        serial,
        publishPicker,
        Site,
        sites,
        applause,
    },
    data() {
        return {
            isLoading: false,
            sections: [],
            book: {},
            chapter_id: null,
            section: null,
            publish_at: null,
            pos: {
                target: null,
                show: false,
                section: null,
            },
            selected: {},
            show_desc: false,
        }
    },
    methods: {
        removePublish(v) {
            v.publish_at = null;
        },
        showPicker(v) {
            if (v.characters == 0) {
                alert.warn("０文字のエピソードは公開できません。");
                return;
            }
            this.selected = v;
            setTimeout(() => {$("#publish-modal").modal()} );
        },
        closePicker(ev) {
            this.selected = ev;
            if (ev.span !== null) {
                // 定期更新
                let start = -1;
                for(let i = 0; i < this.sections.length; i++) {
                    let section = this.sections[i];
                    if (section.is_chapter) continue;
                    if (section.characters == 0) break;
                    if (start !== -1) {
                        if (ev.span == -1) {
                            section.publish_at = null;
                        } else {
                            start = moment(start).add(ev.span, 'minutes');
                            section.publish_at = start.format('YYYY-MM-DD HH:mm:ss');
                        }
                    } else if (section.id == this.selected.id) {
                        start = moment(this.selected.publish_at);
                    }
                }
            }
            setTimeout(() => {this.fillPublish()});
        },
        fillPublish() {
            let prev = null;
            for (let i = this.sections.length - 1; i >= 0; i--) {
                if (this.sections[i].is_chapter) continue;
                if (prev && !this.sections[i].publish_at) {
                    this.sections[i].publish_at = prev;
                } else {
                    prev = this.sections[i].publish_at;
                }
            }
        },
        load(bottom = false) {
            this.loadSections(bottom);
            this.loadBook();
        },
        loadSections(bottom) {
            axios.get("/mypage/book/sections/get", {params: {id: this.$route.params.book_id}}).then(res => {
                let order = 1;
                for (let s of res.data) {
                    s.publish_org = s.publish_at;
                    if (!s.is_chapter) {
                        s.order = order++;
                    }
                }
                this.sections = res.data;
                this.selected = {};
                if (bottom) {
                    $("html,body").animate({scrollTop: $(document).height()}, 500);
                }
            }).catch(err => {
                alert.err(err.response);
            });
        },
        loadBook() {
            // 本
            this.isLoading = true;
            axios.get("/mypage/book/get", {params: {id: this.$route.params.book_id}}).then(res => {
                this.book = res.data;
                setTimeout(() => {
                    $('[data-toggle="tooltip"]').tooltip();
                });
                this.isLoading = false;
            }).catch(err => {
                alert.err(err.response);
                this.isLoading = false;
            });
        },
        isPublished(at) {
            return moment(at).isSameOrBefore(moment());
        },
        remove(v) {
            Swal.fire({
                title: "本文の削除",
                html: `<div class="text-left">
                    指定の本文<br/>
                    <b>${v.section_name||'(無題)'}</b><br/>
                    を削除します。<br/>
                    話は即座に削除され、もとに戻せません。<br/>
                    よろしいですか？</div>
                `,
                icon: "error",
                showCancelButton: true,
                confirmButtonColor: "crimson",
                cancelButtonColor: "gray",
                confirmButtonText: "削除",
                cancelButtonText: "キャンセル",
                reverseButtons: true,
            }).then(confirm => {
                if (confirm.isConfirmed) {
                    this.isLoading = true;
                    axios.post("/mypage/book/section/remove", {id: v.id}).then(res => {
                        alert.msg(res.data);
                        this.load();
                    }).catch(err => {
                        alert.err(err.response);
                    }).finally(() => {
                        this.isLoading = false;
                    });
                }
            });
        },
        removeAll() {
            Swal.fire({
                title: "下書きの一括削除",
                html: `<div class="text-left">
                    <b>下書きの本文</b>を一括で削除します。
                    本文は即座に削除され、もとに戻せません。<br/>
                    間違いを防ぐため、以下に"削除"と入力してください。</div>
                `,
                icon: "error",
                showCancelButton: true,
                confirmButtonColor: "crimson",
                cancelButtonColor: "gray",
                confirmButtonText: "一括削除",
                cancelButtonText: "キャンセル",
                input: "text",
                reverseButtons: true,
            }).then(confirm => {
                if (confirm.isConfirmed) {
                    if (confirm.value !== '削除') {
                        alert.err('下書きを一括削除するには"削除"と入力してください。');
                        return;
                    }
                    this.isLoading = true;
                    axios.post("/mypage/book/sections/remove-all", {book_id: this.$route.params.book_id}).then(res => {
                        alert.msg(res.data);
                        this.load();
                    }).catch(err => {
                        alert.err(err.response);
                    }).finally(() => {
                        this.isLoading = false;
                    });
                }
            });
        },
        updateStatus() {
            this.isLoading = true;
            axios.post("/mypage/book/sections/update", {
                "sections": this.sections,
            }).then(res => {
                alert.msg(res.data);
                this.load();
            }).catch(err => {
                alert.err(err.response);
            }).finally(() => {
                this.isLoading = false;
            });
        },
        editChapter(id = null) {
            this.chapter_id = id;
            setTimeout(() => {
                $("#chapter-modal").modal();
            });
        },
        deleteChapter(id) {
            Swal.fire({
                title: "章削除",
                html: `章を削除します。<br>
                章を削除しても、本文が消えることはありません。`,
                icon: "warning",
                showCancelButton: true,
                cancelButtonText: "キャンセル",
                confirmButtonText: "章削除",
                confirmButtonColor: "crimson",
                reverseButtons: true,
            }).then(confirm => {
                if (confirm.isConfirmed) {
                    axios.post("/mypage/chapter/remove", {id: id}).then(res => {
                        alert.msg(res.data);
                        this.load();
                    }).catch(err => {
                        alert.err(err.response);
                    });
                }
            });
        },
        moveSection(v) {
            this.section = v;
            setTimeout(() => {$("#move-modal").modal()});
        },
        moveTo(to_id) {
            const from = _.findIndex(this.sections, {id: this.section.id});
            const dest = _.findIndex(this.sections, {id: to_id});   // from抜く前
            this.sections.splice(from, 1);
            const to = _.findIndex(this.sections, {id: to_id});     // from抜いた後
            if (from < dest) {
                // 下がる
                this.sections.splice(to + 1, 0, this.section);
            } else {
                // 上がる
                this.sections.splice(to, 0, this.section);
            }
        },
        showUpload() {
            $("#upload-modal").modal();
        },
        showSerial() {
            $("#serial-modal").modal();
        },
        scrollTo(c) {
            $("html,body").animate({scrollTop: $("#section-" + c.id).offset().top - 100});
        },
        showSites() {
            $("#sites-modal").modal();
        },
        showApplause() {
            $("#applause-modal").modal();
        },
        isInvalid(i) {
            if (i === 0) {
                return false;
            }
            const curr = this.sections[i].publish_at;
            let prev = null;
            for (let n = i - 1; n >= 0; n--) {
                if (! this.sections[n].is_chapter) {
                    prev = this.sections[n].publish_at;
                    break;
                }
            }
            if (typeof prev === "undefined") return false;
            if (moment(curr).isBefore(prev)) {
                return true;
            }
            return false;
        },
        crapCount(applause) {
            let count = 0;
            if (applause.sections.length > 0) {
                for (const s of applause.sections) {
                    count += s.pivot.count;
                }
            }
            return count;
        },
        crapDiff(applause) {
            let diff = 0;
            if (applause.sections.length > 0) {
                for (const s of applause.sections) {
                    diff += (s.pivot.count - s.pivot.known_count);
                }
            }
            return diff;
        },
        toggleDesc() {
            this.show_desc = !this.show_desc;
        }
    },
    computed: {
        isSorted() {
            let order_number = 1;
            for (let i = 0; i < this.sections.length; i++) {
                if (this.sections[i].order_number != order_number) {
                    return true;
                }
                if (this.sections[i].chapter_id) {
                    return true;
                }
                order_number++;
            }
            return false;
        },
        isScheduled() {
            for (let i = 0; i < this.sections.length; i++) {
                if (this.sections[i].publish_org != this.sections[i].publish_at) {
                    return true;
                }
            }
            return false;
        },
        sequel() {
            if (! this.sections.length) return "";
            for (let i = 0; i < this.sections.length; i++) {
                if (this.sections[i].is_finish) {
                    if (moment(this.sections[i].publish_at).isSameOrBefore(moment())) {
                        return "完結";
                    } else {
                        return "完結予定";
                    }
                }
            }
            return "連載中";
        },
        // エピソード数
        episodes() {
            return _.filter(this.sections, {is_chapter: 0}).length;
        },
        // 章一覧
        chapters() {
            return _.filter(this.sections, {is_chapter: 1});
        },
        removable() {
            if (_.find(this.sections, {is_chapter: 0, publish_at: null})) {
                return true;
            }
            return false;
        },
        // 短編は１話のみ
        canAppend() {
            if (!this.book.is_long && this.episodes > 0) {
                return false;
            }
            return true;
        },
        isToggler() {
            if (!this.isSorted && !this.isScheduled) {
                if (this.removable || (this.book.is_long && !this.sections.length)) {
                    return true;
                }
            }
            return false;
        },
        BookisPublished() {
            if (!this.book || this.book.is_hidden === 3) return false;
            const rc = _.find(this.sections, (o) => {
                if (!o.publish_org) return false;
                return moment(o.publish_org).isSameOrBefore(moment());
            });
            if (rc) return true;
            return false;
        },
        url() {
            let subdomain = this.$store.state?.user?.subdomain || "www";
            if (this.book.is_long) {
                return "//" + subdomain + this.$store.state.base_domain + "/author/book/" + this.book.id;
            }
            return "//" + subdomain + this.$store.state.base_domain + "/author/page/" + this.book.id + "/section/" + this.sections[0].id;
        },
        hiddenLevel() {
            let rc;
            if (this.book?.is_hidden === 1) {
                rc = "本棚に表示";
            } else if (this.book?.is_hidden === 2) {
                rc = "非公開";
            } else {
                rc = "保留";
            }
            return rc;
        },
        booksPath() {
            if (this.book?.is_hidden === 3) {
                return "/mypage/books/pending";
            } else if (this.book?.property?.is_finished) {
                return "/mypage/books/finished";
            }
            return "/mypage/books";
        },
        recent() {
            const recent = _.maxBy(this.sections, (o) => {
                if (o.is_chapter) {
                    return -1;
                }
                if (!o.characters) {
                    return 0;
                }
                return moment(o.updated_at).unix();
            });
            if (recent.is_chapter) {
                return null;
            }
            return recent;
        },
        recentUrl() {
            const section = this.recent;
            return `/mypage/book/${this.$route.params.book_id}/section/edit/${section.id}`;
        },
        recentTitle() {
            const section = this.recent;
            return section.section_name || "(無題)";
        },
    },
    watch: {
        '$route'(n, o) {
            if (n.path && n.path.match(/^\/mypage\/book\/\d+\/sections\/$/)) {
                this.load();
                $("html,body").animate({scrollTop: 0}, 500);
            }
        }
    },
    mounted() {
        this.load();
    },
    async beforeRouteLeave(to, from) {
        if (this.isSorted || this.isScheduled) {
            let edit = "";
            if (this.isSorted) edit = "順番";
            if (this.isScheduled) edit += "予定";
            let confirm = await Swal.fire({
                title: "保存されていません",
                html: `<div class="text-left">
                    ${edit}の変更が保存されていません。
                    このままページを離れますか？
                    </div>`,
                icon: "info",
                showCancelButton: true,
                confirmButtonColor: "midnightblue",
                cancelButtonColor: "gray",
                confirmButtonText: "離れる",
                cancelButtonText: "キャンセル",
                reverseButtons: true,
            });
            if (confirm.isConfirmed) {
                return true;
            } else {
                return false;
            }
        } else {
            return true;
        }
    }
}
</script>